module.exports = __webpack_public_path__ + "img/bg_main03_mask_m.bcc7437b.svg";